














































































































import {
    Vue, Component, Prop, PropSync, Mixins, Watch,
} from 'vue-property-decorator'
import axios from 'axios'
import api from '@/api'
import util from '@/util'
import config from '$config'
import Draw from './draw'

@Component
export default class Signature extends Vue {
    @Prop({default() {
        return {
        }
    }}) company !: any        // 公司数据

    @Prop({default: ''}) value!: string

    @Prop({default: ''}) width!: string

    @Prop({default: ''}) height!: string

    @Prop({default: false}) smallWidth!: boolean

    @Prop({default: false}) smallFourWidth!: boolean

    @Prop({default: false}) smallTwoWidth!: boolean

    @Prop({default: false}) positionMargin!: boolean

    @Prop({default: ''}) lastUpdate!: any

    @Prop({default: false}) signTop!: boolean

    // signBottom = true 签名在最底部时 避免自动多出一页
    @Prop({default: false}) signBottom!: boolean

    @Prop({default: false}) limitSize!: boolean

    // true 时只显示一个 Submit 按钮（helper 签字页使用）
    @Prop({default: false}) singleSubmit!: boolean

    get signTopMargin(): string {
        if (this.signBottom) {
            return '-20px'
        }
        return this.signTop ? '20px' : ''
    }

    config: any = config

    signVisible: boolean = false

    degree: number = 0 // 屏幕整体旋转的角度, 可取 -90,90,180等值

    canvasBox: any = null

    canvas: any = null

    draw: any = null

    signed: boolean = false

    saveLoading: boolean = false

    confirmDlg: boolean = false

    saveAllLoading: boolean = false

    isUploadAll: boolean = false

    @Watch('signVisible')
    handleSignVisibleChange(newVal) {
        this.signed = false
    }

    showSignDlg() {
        if (this.lastUpdate) {
            this.$emit('updateSrc')
        } else {
            this.signVisible = true
            this.$nextTick(() => {
                this.canvasBox = this.$refs.canvasBox
                this.canvasBox.removeChild(this.canvasBox.querySelector('canvas'))
                this.canvasBox.appendChild(document.createElement('canvas'))
                setTimeout(() => {
                    this.initCanvas()
                }, 200)
            })
        }
    }

    showRepeatDlg() {
        this.signVisible = true
        this.$nextTick(() => {
            this.canvasBox = this.$refs.canvasBox
            this.canvasBox.removeChild(this.canvasBox.querySelector('canvas'))
            this.canvasBox.appendChild(document.createElement('canvas'))
            setTimeout(() => {
                this.initCanvas()
            }, 200)
        })
    }

    initCanvas() {
        const canvas:any = this.canvasBox.querySelector('canvas')
        this.canvas = canvas
        this.draw = new Draw(canvas, -this.degree, this)
    }

    clear() {
        this.signed = false
        this.draw.clear()
    }

    cancel() {
        this.confirmDlg = false
    }

    confirm() {
        this.saveLoading = true
        let formData = new FormData()
        let dataUrl = this.canvas.toDataURL()
        let file = util.dataURItoBlob(dataUrl)
        formData.append('file', file, 'test.png')
        api.upload_file(formData)
            .then(({data}) => {
                this.$emit('input', data)
                this.$emit('getLastUpdate', data)
                if (this.isUploadAll) {
                    this.$emit('setAllSrc', data)
                } else {
                    this.$emit('updateSigned', data)
                }
                this.isUploadAll = false
                this.signVisible = false
                this.confirmDlg = false
            })
            .finally(() => {
                this.saveLoading = false
            })
    }

    upload() {
        const list = this.draw.inputList
        const flag = list.every(count => count <= 60)
        if (flag) {
            return this.$message.error('Please draw your signature properly.')
        }

        if (this.lastUpdate) {
            this.confirmDlg = true
            return
        }
        this.saveLoading = true
        let formData = new FormData()
        let dataUrl = this.canvas.toDataURL()
        let file = util.dataURItoBlob(dataUrl)
        formData.append('file', file, 'test.png')
        api.upload_file(formData)
            .then(({data}) => {
                this.$emit('input', data)
                this.$emit('getLastUpdate', data)
                this.signVisible = false
            })
            .finally(() => {
                this.saveLoading = false
            })
    }

    uploadAll() {
        const list = this.draw.inputList
        const flag = list.every(count => count <= 60)
        if (flag) {
            return this.$message.error('Please draw your signature properly.')
        }
        if (this.lastUpdate) {
            this.isUploadAll = true
            this.confirmDlg = true
            return
        }
        this.saveAllLoading = true
        let formData = new FormData()
        let dataUrl = this.canvas.toDataURL()
        let file = util.dataURItoBlob(dataUrl)
        formData.append('file', file, 'test.png')
        api.upload_file(formData)
            .then(({data}) => {
                this.$emit('input', data)
                this.$emit('setAllSrc', data)
                this.$emit('getLastUpdate', data)
                this.signVisible = false
            })
            .finally(() => {
                this.saveAllLoading = false
            })
    }
}
